<template>
    <div class="habit-icon" :class="`habit-icon--${tone}`" :style="{ width: `${size}px`, height: `${size}px`, minWidth: `${size}px` }">
        <v-icon :size="Math.round(size * .5)">{{ icon }}</v-icon>
    </div>
</template>

<script>
import { HABIT_CATEGORY_ICONS } from '@/utils/Habits'

export default {
    name: 'HabitIcon',
    props: {
        category: {
            type: String,
            default: 'custom',
        },
        combo: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 36,
        },
    },
    computed: {
        icon(vm = this) {
            if (vm.combo) return 'mdi-view-grid-outline'
            return HABIT_CATEGORY_ICONS[vm.category] || HABIT_CATEGORY_ICONS.custom
        },
        tone(vm = this) {
            if (vm.combo) return 'accent'
            return ['nutrition', 'supplements'].includes(vm.category) ? 'green' : 'accent'
        },
    },
}
</script>

<style scoped>
.habit-icon {
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: rgba(51, 153, 153, .12);
    border: 1px solid rgba(51, 153, 153, .25);
}

.habit-icon--green {
    background: rgba(0, 153, 102, .12);
    border-color: rgba(0, 153, 102, .25);
}

.habit-icon .v-icon {
    color: var(--v-accent-base) !important;
}

.habit-icon--green .v-icon {
    color: var(--v-success-base) !important;
}
</style>
